import React from 'react';
import PropTypes from 'prop-types';

import { BookingWhatSection, BookingWhatHeading, BookingWhatDescription } from './styles';

const BookingWhatYouGet = ({ children }) => (
  <BookingWhatSection>
    <BookingWhatHeading>What you get</BookingWhatHeading>
    <BookingWhatDescription dangerouslySetInnerHTML={{ __html: children }} />
  </BookingWhatSection>
);

BookingWhatYouGet.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BookingWhatYouGet;
